import React, { useState, useEffect, useContext } from "react";

import { Link } from "react-router-dom";
import { ThemeContext } from "styled-components";
// import ReactExport from "react-export-excel";

/* import services */
import api from "./../../services/api";

/* import utils */
import { filterString, getDate, getDateByTimeZoneCba } from "./../../util/functions";
import { NotifyContext } from "./../../util/notify";

import { useTheme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import Legend from "./../../components/Legend";
import Search from "./../../components/Search";

/* import icons */
import AddPageIcon from "./../../assets/icons/addPage";

/* import styles */
import { Container, Cards, Card, Title, Subtitle, Comment } from "./styles";
import { Actions, ActionEditIcon, ActionPresentIcon, ActionCardMembershipIcon, ActionDoneAllIcon } from "./styles";
import { ActionCloudDownloadIcon } from "./styles";
import { ActionSubscribersIcon, ActionSpeakersIcon } from "./styles";

//   const ExcelFile = ReactExport.ExcelFile;
//   const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
//   const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default function Contact({ toggleTitles }) {
  toggleTitles("Cursos", "Agenda de cursos");

  const { status: colors } = useContext(ThemeContext);
  const { notify } = useContext(NotifyContext);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [searchValue, setSearchValue] = useState("");
  const [searchStatus, setSearchStatus] = useState("");

  const [paginate, setPaginate] = useState({});
  const [data, setData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  const [ratingsModalOpen, setRatingsModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [ratings, setRatings] = useState([]);
  const [loadingRatings, setLoadingRatings] = useState(false);

  const handleFilter = async text => {
    const filtered = initialData.filter(
      item =>
        filterString(item.is_active ?? false, (searchStatus === "inative" ? false : true) ?? "") &&
        (filterString(item.id, text) ||
          filterString(item.name, text) ||
          filterString(item.address ?? "", text) ||
          filterString(item.local ?? "", text) ||
          filterString(item.instructors ?? "", text) ||
          filterString(getDate(item.start_date, "dd'/'MM'/'yyyy"), text) ||
          filterString(item.start_date ? getDate(item.start_date, "dd'/'MM'/'yyyy") : "", text) ||
          filterString(item.uri ?? "", text)),
    );
    setData(filtered);
  };

  async function loadData() {
    notify.show(true, "Carregando", "info");
    try {
      const { data } = await api.get(`/courses/panel`, { headers: { pagelimit: 10000, pagenumber: 1 } });
      await setInitialData(data);
      await setData(data);
      setPaginate({ lastPage: 0, page: 0, perPage: 0, total: "0" });
    } catch (error) {
      console.log(error);
    }
    notify.show(false, "Carregando", "info");
  }

  useEffect(() => {
    handleFilter(searchValue);
  }, [searchStatus]);

  const handleOpenRatings = async course => {
    setSelectedCourse(course);
    setRatingsModalOpen(true);
    setLoadingRatings(true);
    setRatings([]);

    try {
      const { data } = await api.get(`/courses/${course.id}/ratings`);
      setRatings(data);
    } catch (error) {
      console.error("Erro ao carregar avaliações:", error);
      notify.show(true, "Erro ao carregar avaliações", "error");
    } finally {
      setLoadingRatings(false);
    }
  };

  const handleCloseRatings = () => {
    setRatingsModalOpen(false);
    setSelectedCourse(null);
    setRatings([]);
  };

  useEffect(() => {
    loadData();
    document.querySelector("#input").focus();
  }, []);

  return (
    <>
      <Container>
        <Legend
          active={searchStatus}
          onClick={status => {
            setSearchStatus(status);
          }}
          items={[
            {
              key: "status",
              value: "active",
              title: "Filtrar Ativos",
              color: colors["active"],
            },
            {
              key: "status",
              value: "inative",
              title: "Filtrar Inativos",
              color: colors["inative"],
            },
          ]}
        />
        <Cards>
          {data.map(({ id, name, start_date, end_date, local, summary, uri, is_active, is_virtual, course_subscribes, rating_metrics }) => (
            <>
              <Card key={id} status={colors[is_active ? "active" : "inative"]}>
                <Actions>
                  <Link to={`/curso/editar/${id}`}>
                    <ActionEditIcon />
                  </Link>
                  {/* <Link to={`/curso/presenca/${id}`} title="Definir presença">
                    <ActionDoneAllIcon />
                  </Link> */}
                  <Link to={`/curso/inscritos/${id}`} title="Gerenciar inscritos">
                    <ActionSubscribersIcon />
                  </Link>
                  <Link to={`/curso/palestrantes/${id}`} title="Gerenciar palestrantes">
                    <ActionSpeakersIcon />
                  </Link>
                  <a href={`/curso/inscricoes/${id}`} title="Imprimir lista de inscritos" target="_blank">
                    <ActionCardMembershipIcon />
                  </a>
                  <a href={`/curso/inscricoes/${id}/true`} title="Imprimir lista de presentes" target="_blank">
                    <ActionPresentIcon />
                  </a>
                  {/* <ExcelFile title="Baixar Lista de Inscritos" element={<ActionCloudDownloadIcon />} filename={`${name} - Relatorio de inscritos`}>
                    <ExcelSheet data={course_subscribes} name={`${name} - Relatorio de inscritos`}>
                      <ExcelColumn label="Nome/Usuário" value={col => col.site_user.name} />
                      <ExcelColumn label="CPF" value={col => col.site_user.cpf} />
                      <ExcelColumn label="Presente?" value={col => (col.present ? "SIM" : "NÃO")} />
                    </ExcelSheet>
                  </ExcelFile> */}
                </Actions>

                <Title>{name}</Title>
                <Subtitle>
                  {local}
                  <br />
                  <br />
                  {is_virtual ? "Curso virtual" : ""}
                </Subtitle>
                <Comment>
                  {id > 50 ? (
                    <>
                      {getDateByTimeZoneCba(start_date, "dd'/'MM'/'yyyy 'às' HH':'mm ")}
                      {end_date ? getDateByTimeZoneCba(end_date, "' até 'dd'/'MM'/'yyyy 'às' HH':'mm") : ""}
                    </>
                  ) : (
                    <>
                      {getDate(start_date, "dd'/'MM'/'yyyy 'às' HH':'mm ")}
                      {end_date ? getDate(end_date, "' até 'dd'/'MM'/'yyyy 'às' HH':'mm") : ""}
                    </>
                  )}
                </Comment>

                {rating_metrics && rating_metrics.total > 0 && (
                  <div
                    onClick={() => handleOpenRatings({ id, name, rating_metrics })}
                    style={{
                      marginTop: "15px",
                      padding: "15px",
                      background: "linear-gradient(135deg, #fff9e6 0%, #fff5d6 100%)",
                      borderRadius: "8px",
                      border: "1px solid #ffd700",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                      width: "100%",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.05)";
                    }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <div style={{ fontWeight: "bold", fontSize: "13px", color: "#333", textTransform: "uppercase", letterSpacing: "0.5px" }}>Avaliações do Curso</div>
                        <span style={{ fontSize: "10px", color: "#999", fontStyle: "italic" }}>(clique para ver todas)</span>
                      </div>
                      <div style={{ fontSize: "11px", color: "#666", backgroundColor: "#fff", padding: "4px 8px", borderRadius: "12px" }}>
                        {rating_metrics.total} {rating_metrics.total === 1 ? "avaliação" : "avaliações"}
                      </div>
                    </div>

                    <div
                      style={{
                        justifyContent: "space-between",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "15px",
                        paddingBottom: "12px",
                        borderBottom: "1px solid rgba(255,215,0,0.3)",
                      }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        {[1, 2, 3, 4, 5].map(star => (
                          <span
                            key={star}
                            style={{
                              fontSize: "22px",
                              color: star <= Math.round(rating_metrics.average) ? "#FFD700" : "#E0E0E0",
                              transition: "color 0.2s",
                            }}>
                            ★
                          </span>
                        ))}
                      </div>
                      <div style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
                        <span style={{ fontWeight: "bold", fontSize: "24px", color: "#333" }}>{rating_metrics.average.toFixed(1)}</span>
                        <span style={{ color: "#999", fontSize: "14px" }}>/ 5.0</span>
                      </div>
                    </div>

                    <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                      {[5, 4, 3, 2, 1].map(rating => {
                        const count = rating_metrics.distribution[rating];
                        const percentage = rating_metrics.total > 0 ? (count / rating_metrics.total) * 100 : 0;
                        const colors = {
                          5: "#4CAF50",
                          4: "#8BC34A",
                          3: "#FFC107",
                          2: "#FF9800",
                          1: "#F44336",
                        };

                        return (
                          <div key={rating} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "4px", minWidth: "50px" }}>
                              <span style={{ fontSize: "14px", color: "#FFD700" }}>★</span>
                              <span style={{ fontWeight: "600", fontSize: "12px", color: "#333", minWidth: "20px" }}>{rating}</span>
                            </div>
                            <div
                              style={{
                                flex: 1,
                                height: "18px",
                                backgroundColor: "#f0f0f0",
                                borderRadius: "9px",
                                overflow: "hidden",
                                position: "relative",
                              }}>
                              <div
                                style={{
                                  width: `${percentage}%`,
                                  height: "100%",
                                  backgroundColor: colors[rating],
                                  borderRadius: "9px",
                                  transition: "width 0.3s ease",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                  paddingRight: "6px",
                                }}>
                                {percentage > 15 && <span style={{ color: "#fff", fontSize: "10px", fontWeight: "bold" }}>{count}</span>}
                              </div>
                              {percentage <= 15 && count > 0 && (
                                <span
                                  style={{
                                    position: "absolute",
                                    left: "6px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    color: "#666",
                                    fontSize: "10px",
                                    fontWeight: "600",
                                  }}>
                                  {count}
                                </span>
                              )}
                            </div>
                            <div style={{ minWidth: "35px", textAlign: "right" }}>
                              <span style={{ fontSize: "11px", color: "#666", fontWeight: "500" }}>{count}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </Card>
            </>
          ))}
        </Cards>

        <Search
          InitialValue={searchValue}
          onChange={text => {
            setSearchValue(text);
            handleFilter(text);
          }}
          btnAdd
          btnAddTo="/curso/novo"
          btnAddIcon={<AddPageIcon />}
          btnAddtitle="Adicionar Curso"
        />
      </Container>

      <Dialog fullScreen={fullScreen} open={ratingsModalOpen} onClose={handleCloseRatings} aria-labelledby="ratings-dialog-title" maxWidth="md" fullWidth>
        <DialogTitle id="ratings-dialog-title">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span>
              Avaliações - {selectedCourse?.name}
              {selectedCourse?.rating_metrics && (
                <span style={{ marginLeft: "10px", fontSize: "14px", color: "#666", fontWeight: "normal" }}>
                  ({selectedCourse.rating_metrics.total} {selectedCourse.rating_metrics.total === 1 ? "avaliação" : "avaliações"})
                </span>
              )}
            </span>
            {selectedCourse?.rating_metrics && (
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <span style={{ fontSize: "18px", color: "#FFD700" }}>★</span>
                <span style={{ fontWeight: "bold", fontSize: "16px" }}>{selectedCourse.rating_metrics.average.toFixed(1)}</span>
                <span style={{ color: "#999", fontSize: "12px" }}>/ 5.0</span>
              </div>
            )}
          </div>
        </DialogTitle>
        <DialogContent>
          {loadingRatings ? (
            <div style={{ padding: "40px", textAlign: "center", color: "#666" }}>Carregando avaliações...</div>
          ) : ratings.length === 0 ? (
            <div style={{ padding: "40px", textAlign: "center", color: "#666" }}>Nenhuma avaliação encontrada</div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "16px", paddingTop: "10px" }}>
              {ratings.map((rating, index) => (
                <div
                  key={rating.id || index}
                  style={{
                    padding: "16px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                  }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "10px" }}>
                    <div>
                      <div style={{ fontWeight: "bold", fontSize: "14px", color: "#333", marginBottom: "4px" }}>{rating.site_user?.name || "Usuário não identificado"}</div>
                      <div style={{ fontSize: "12px", color: "#666" }}>
                        {rating.site_user?.cpf || ""} {rating.site_user?.email ? `• ${rating.site_user.email}` : ""}
                      </div>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      {[1, 2, 3, 4, 5].map(star => (
                        <span
                          key={star}
                          style={{
                            fontSize: "18px",
                            color: star <= rating.rating ? "#FFD700" : "#E0E0E0",
                          }}>
                          ★
                        </span>
                      ))}
                      <span style={{ marginLeft: "6px", fontWeight: "bold", fontSize: "16px", color: "#333" }}>{rating.rating}/5</span>
                    </div>
                  </div>
                  {rating.comment && (
                    <div
                      style={{
                        marginTop: "10px",
                        padding: "12px",
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        borderLeft: "3px solid #ffd700",
                        fontSize: "13px",
                        color: "#555",
                        lineHeight: "1.5",
                        fontStyle: "italic",
                      }}>
                      "{rating.comment}"
                    </div>
                  )}
                  {rating.created_at && <div style={{ marginTop: "8px", fontSize: "11px", color: "#999" }}>{getDate(rating.created_at, "dd'/'MM'/'yyyy 'às' HH':'mm")}</div>}
                </div>
              ))}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseRatings} color="secondary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
